import { useEffect, useRef } from "react";
import { useMouseCtx } from "@/providers/AppProviders";

// Smooth 3D tilt driven by global mouse position (max degrees).
export function useTilt(max = 8) {
  const mouse = useMouseCtx();
  const ref = useRef(null);
  useEffect(() => {
    let raf;
    let rx = 0;
    let ry = 0;
    const loop = () => {
      if (ref.current && mouse && mouse.current) {
        const tx = -mouse.current.y * max;
        const ty = mouse.current.x * max;
        rx += (tx - rx) * 0.08;
        ry += (ty - ry) * 0.08;
        ref.current.style.transform = `perspective(1100px) rotateX(${rx}deg) rotateY(${ry}deg)`;
      }
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, [max, mouse]);
  return ref;
}
